module.exports = __webpack_public_path__ + "img/LEGAL-WG.39a237b2.svg";